module.exports = __webpack_public_path__ + "img/ep6-2.e3bfd694.png";